import { getLiveTagValue } from "@/features/datapoints/api/getLiveTagValue"

import type { DigesterConfig } from "../types/feedstockTypes"

export const getLiveDigesterData = async (
  digesters: DigesterConfig[],
  row: number,
): Promise<(number | undefined)[]> => {
  return await Promise.all(
    digesters.map((d) => {
      const tagPath = d.tagPaths[row]

      // Some digesters deliberately have no sensor for a metric (BCO 514's
      // gas-flow meter is the current example). Keep that one cell N/A rather
      // than rejecting the entire row before the other live-tag requests run.
      return tagPath ? getLiveTagValue(tagPath) : undefined
    }),
  )
}
